import { createSelector } from '@ngrx/store';
import { ProtocolState } from '../state/protocol.state';
import { AppState } from '../state/state';
import { InterimModel } from '../../interfaces/interim.interface';
import { EquipmentModel } from '../../interfaces/equipment.interface';

export const selectProtocols = (state: AppState): ProtocolState => state.protocols;

export const isEquipmentsLoading = createSelector(selectProtocols, (state: ProtocolState): boolean => state.isLoading);

export const equipments = createSelector(selectProtocols, (state: ProtocolState): EquipmentModel[] => state.equipments);

export const interims = createSelector(selectProtocols, (state: ProtocolState): InterimModel[] => state.interims);

export const getOrderNumber = createSelector(equipments, (eqs): string => eqs[0].OrderNumber);

export const getEquipmentDescription = createSelector(equipments, (eqs): string => eqs[0].Description);

export const getMaterialNumber = createSelector(equipments, (eqs): string => eqs[0].PartNo);

export const getSerialNumber = createSelector(equipments, (eqs): string => eqs[0].SerialNo);
